module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('demonstration', {
    attrs: {
      "tag": "h2",
      "title": "Pagination 分页",
      "description": "当数据量过多时，使用分页分解数据。",
      "show-content": false
    }
  }), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "基础用法",
      "anchor": "demo-code-title",
      "highlight": _vm.sourcecode1
    }
  }, [_c('template', {
    slot: "description"
  }, [_vm._v("\n            简单描述一下示例代码标题\n        ")]), _vm._v(" "), _c('template', {
    slot: "source"
  }, [_c('div', {
    staticClass: "source first"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "demonstration"
  }, [_vm._v("页数较少时的效果")]), _vm._v(" "), _c('vm-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "total": 50
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "demonstration"
  }, [_vm._v("大于 7 页时的效果")]), _vm._v(" "), _c('vm-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "total": 1000
    }
  })], 1)])]), _vm._v(" "), _c('template', {
    slot: "explanation"
  }, [_vm._v("\n            设置 "), _c('code', [_vm._v("layout")]), _vm._v(" ，表示需要显示的内容，用逗号分隔，布局元素会依次显示。"), _c('code', [_vm._v("prev")]), _vm._v(" 表示上一页，"), _c('code', [_vm._v("next")]), _vm._v("为下一页，"), _c('code', [_vm._v("pager")]), _vm._v("表示页码列表，除此以外还提供了"), _c('code', [_vm._v("jumper")]), _vm._v("和"), _c('code', [_vm._v("total")]), _vm._v("，"), _c('code', [_vm._v("size")]), _vm._v("和特殊的布局符号->，->后的元素会靠右显示，"), _c('code', [_vm._v("jumper")]), _vm._v("表示跳页元素，"), _c('code', [_vm._v("total")]), _vm._v("表示显示页码总数，"), _c('code', [_vm._v("size")]), _vm._v("用于设置每页显示的页码数量。\n        ")])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "小型分页",
      "anchor": "demo-code-title",
      "highlight": _vm.sourcecode2
    }
  }, [_c('template', {
    slot: "description"
  }, [_vm._v("\n            在空间有限的情况下，可以使用简单的小型分页。\n        ")]), _vm._v(" "), _c('template', {
    slot: "source"
  }, [_c('div', {
    staticClass: "source"
  }, [_c('vm-pagination', {
    attrs: {
      "small": "",
      "layout": "prev, pager, next",
      "total": 50
    }
  })], 1)]), _vm._v(" "), _c('template', {
    slot: "explanation"
  }, [_vm._v("\n            只需要一个"), _c('code', [_vm._v("small")]), _vm._v("属性，它接受一个"), _c('code', [_vm._v("Boolean")]), _vm._v("，默认为"), _c('code', [_vm._v("false")]), _vm._v("，设为"), _c('code', [_vm._v("true")]), _vm._v("即可启用。\n        ")])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "附加功能",
      "anchor": "demo-code-title",
      "highlight": _vm.sourcecode3
    }
  }, [_c('template', {
    slot: "description"
  }, [_vm._v("\n            根据场景需要，可以添加其他功能模块。\n        ")]), _vm._v(" "), _c('template', {
    slot: "source"
  }, [_c('div', {
    staticClass: "source last"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "demonstration"
  }, [_vm._v("显示总数")]), _vm._v(" "), _c('vm-pagination', {
    attrs: {
      "current-page": _vm.currentPage1,
      "page-size": 100,
      "layout": "total, prev, pager, next",
      "total": 1000
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage1 = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "demonstration"
  }, [_vm._v("调整每页显示条数")]), _vm._v(" "), _c('vm-pagination', {
    attrs: {
      "current-page": _vm.currentPage2,
      "page-sizes": [100, 200, 300, 400],
      "page-size": 100,
      "layout": "sizes, prev, pager, next",
      "total": 1000
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage2 = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "demonstration"
  }, [_vm._v("直接前往")]), _vm._v(" "), _c('vm-pagination', {
    attrs: {
      "current-page": _vm.currentPage3,
      "page-size": 100,
      "layout": "prev, pager, next, jumper",
      "total": 1000
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage3 = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "demonstration"
  }, [_vm._v("完整功能")]), _vm._v(" "), _c('vm-pagination', {
    attrs: {
      "current-page": _vm.currentPage4,
      "page-sizes": [100, 200, 300, 400],
      "page-size": 100,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": 400
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])]), _vm._v(" "), _c('template', {
    slot: "explanation"
  }, [_vm._v("\n            此例是一个完整的用例，使用了"), _c('code', [_vm._v("size-change")]), _vm._v("和"), _c('code', [_vm._v("current-change")]), _vm._v(" 事件来处理页码大小和当前页变动时候触发的事件。"), _c('code', [_vm._v("page-sizes ")]), _vm._v(" 接受一个整型数组，数组元素为展示的选择每页显示个数的选项，"), _c('code', [_vm._v("[100, 200, 300, 400]")]), _vm._v(" 表示四个选项，每页显示 100 个，200 个，300 个或者 400 个。\n        ")])], 2), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-demo__item"
  }, [_c('h3', {
    attrs: {
      "id": "attributes"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "./#attributes",
      "aria-hidden": "true"
    }
  }, [_vm._v("¶")]), _vm._v("\n            Attributes\n        ")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("可选值")]), _vm._v(" "), _c('th', [_vm._v("默认值")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("small")]), _vm._v(" "), _c('td', [_vm._v("是否使用小型分页样式")]), _vm._v(" "), _c('td', [_vm._v("Boolean")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("false")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("page-size")]), _vm._v(" "), _c('td', [_vm._v("每页显示条目个数")]), _vm._v(" "), _c('td', [_vm._v("Number")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("10")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("total")]), _vm._v(" "), _c('td', [_vm._v("总条目数")]), _vm._v(" "), _c('td', [_vm._v("Number")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("page-count")]), _vm._v(" "), _c('td', [_vm._v("总页数，total 和 page-count 设置任意一个就可以达到显示页码的功能；如果要支持 page-sizes 的更改，则需要使用 total 属性")]), _vm._v(" "), _c('td', [_vm._v("Number")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("current-page")]), _vm._v(" "), _c('td', [_vm._v("当前页数，支持 .sync 修饰符")]), _vm._v(" "), _c('td', [_vm._v("Number")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("1")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("layout")]), _vm._v(" "), _c('td', [_vm._v("组件布局，子组件名用逗号分隔")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("sizes, prev, pager, next, jumper, ->, total, slot")]), _vm._v(" "), _c('td', [_vm._v("'prev, pager, next, jumper, ->, total'")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("page-sizes")]), _vm._v(" "), _c('td', [_vm._v("每页显示个数选择器的选项设置")]), _vm._v(" "), _c('td', [_vm._v("Number[]")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("[10, 20, 30, 40, 50, 100]")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-demo__item"
  }, [_c('h3', {
    attrs: {
      "id": "event"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "./#event",
      "aria-hidden": "true"
    }
  }, [_vm._v("¶")]), _vm._v("\n            Events\n        ")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('th', [_vm._v("事件名称")]), _vm._v(" "), _c('th', [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("回调参数")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("size-change")]), _vm._v(" "), _c('td', [_vm._v("pageSize 改变时会触发")]), _vm._v(" "), _c('td', [_vm._v("每页条数size")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("current-change")]), _vm._v(" "), _c('td', [_vm._v("currentPage 改变时会触发")]), _vm._v(" "), _c('td', [_vm._v("当前页currentPage")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-demo__item"
  }, [_c('h3', {
    attrs: {
      "id": "slot"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "./#slot",
      "aria-hidden": "true"
    }
  }, [_vm._v("¶")]), _vm._v("\n            Slot\n        ")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("说明")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("自定义内容，需要在 layout 中列出 slot")])])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-38e8bd4a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38e8bd4a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./example/src/App.vue
// module id = 21
// module chunks = 0